import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function StaffDetails() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Staff Details</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Staff Details</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Staff Details</h1>
                        </div>
                        <div class="col-12 curr-blk">
                            <div class="staffboxsec">
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/principal.jpg" />
                                    </div>
                                    <div class="desc">
                                        <p> Fr.Dinu M Daniel <span> PRINCIPAL </span><span> B.Sc, B.Ed, M.Ed </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/ARTI RANI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Arti Rani <span> Teacher </span><span> I.A MONTESSORI T. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/ANURADHA PATHAK.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Anuradha Pathak <span> Teacher </span><span> B.A. VOCAL, DANCE (B. MUSIC) </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/ABANTI NANDY.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Abanti Nandy <span> Teacher </span><span> B.Sc., B.Ed. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/SUCHITA DAS.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Suchita Das <span> Teacher </span><span> B.Sc., B.MUSIC </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/MAMTA TIWARY.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Mamta Tiwary <span> Teacher </span><span> B.A., N.T.T., B.Ed </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/ANNU.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Annu <span> Teacher </span><span> B.A., N.T.T. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/POONAM JHA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Poonam Jha <span> Teacher </span><span> B.Sc., B.Ed., CTET </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/RAMA MANDAL.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Rama Mandal <span> Teacher </span><span> B.A. VOCAL, B.Sc. (PHYSICS) </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/KUMARI URVASHI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Ms. Kumari. Urvashi <span> Teacher </span><span> B.A.,(Hindi Hon.) B.Ed. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/FARHEEN SADAF.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Farheen Sadaf <span> Teacher </span><span> B.A (SOCIOLOGY HONS.), B. Ed </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/PRATIMA_KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Pratima Kumari <span> Teacher </span><span> B.Com, NTT </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/NITU KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Nitu Kumari <span> Teacher </span><span> M.A ., B.Ed. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/DOLLY KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Dolly Kumari <span> Teacher </span><span> M.A. (ENGLISH), B.Ed. </span></p>
                                    </div>
                                </div>
                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/GITA KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Gita Kumari <span> Teaching Staff </span><span> M.A., DLED, CTET PAPER I &amp; II
                                        </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/MAYA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Maya <span> Teacher </span><span> M.A. (HISTORY), B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/RASHMI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Miss. Rashmi <span> Teacher </span><span> B.Sc (Zoology (Hns.), B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/PREETI SHARMA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Preeti Sharma <span> Teacher </span><span> M.A., B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/ANSHU KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Anshu Kumari <span> Teacher </span><span> M.A., B.Ed. </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/NEETU RANI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Miss. Neetu Rani <span> Teacher </span><span> B.P. Ed. </span></p>
                                    </div>
                                </div>




                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/REENA KUMARI.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Reena Kumari <span> Teacher </span><span> B.A., N.T.T. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/KOMAL.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Komal <span> Teacher </span><span> M.B.A (HR), NTT - 1 YR. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/ANKITA GUPTA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Miss. Ankita Gupta <span> Teacher </span><span> B.B.A (Pursuing), N.T.T - 1 YRS. </span>
                                        </p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/MEHAJABIN PARVEEN.JPG " />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Mehjabin Parveen <span> Teacher </span><span> M.A., B.Ed. </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/SOBHY THOMAS.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Sobhy Thomas <span> Office Assistant </span><span> P.D.C., Stenography &amp;
                                            Computer (D.C.A) </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/PARVATI KERKETTA.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Parvati Kerketta <span> Ayah </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/MANOJ KUMAR NAPIT.jpeg" />
                                    </div>
                                    <div class="desc">
                                        <p> Mr. Manoj Kumar Napit <span> Watchman </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>


                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/TRIBENI KR. MAHATHA.jpeg" />
                                    </div>
                                    <div class="desc">
                                        <p> Mr. Tribeni Kr. Mahatha <span> Watchman </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/SAGAR GOPE.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mr. Sagar Gope <span> Maali </span>
                                            <span> Non-Matriculate </span>
                                        </p>
                                    </div>
                                </div>

                                <div class="staffbox">
                                    <div class="imgbox">
                                        <img class="img-fluid mx-auto d-block "
                                            src="https://webapi.entab.info/api/image/SMNSB/public/images/LUCY TIRKEY.JPG" />
                                    </div>
                                    <div class="desc">
                                        <p> Mrs. Lucy Tirkey <span> Ayah </span><span> Non-Matriculate </span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default StaffDetails